import React from 'react';

import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";
import DropdownProviderEYFSGroups from "root/ReactHookForm/ui/DropdownProviderEYFSGroups";
import DropdownProviderEYFSGroupMembers from "root/ReactHookForm/ui/DropdownProviderEYFSGroupMembers";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";

import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents";
import {FormSectionNames} from "root/s360components/LearningJournal/LearningJournalPage";
import DropdownProviderEYFSParentPupils from "root/ReactHookForm/ui/DropdownProviderEYFSParentPupils";

export const groupAndChild = () =>
{
    return {
        [FormSectionNames.GROUP_AND_CHILD]:
            {
                eyfs_group_id: null,
                child_id: null,
            }
    }
}

const HookSubFormGroupAndPupil = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const validateChild = (val) =>
    {
        if (val === null)
        {
            return "Please Select a Child.";
        }
    }

    return (
        <S360WidgetBlock title='Select a Pupil'>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <DropdownProviderEYFSParentPupils name={sectionName + '.child_id'} control={control} rules={{validate: validateChild}}
                                                      placeHolder='Pick a Child' readOnly={ false }/>
                </BootstrapCol>
            </BootstrapRow>
        </S360WidgetBlock>
    )
}


export default HookSubFormGroupAndPupil;
